<template>
  <div class="form form-grid">
    <div class="field width-1 height-1 bg-primary text-white"> M1 </div>
    <div class="field width-1 height-1 bg-primary text-white"> M2 </div>
    <div class="field width-1 height-1 bg-primary text-white"> M3 </div>
    <div class="field width-1 height-1 bg-primary text-white"> M4 </div>
    <div class="field width-1 height-1 bg-primary text-white"> M5 </div>
    <div class="field width-1 height-1 bg-primary text-white"> M6 </div>
    <div class="field width-1 height-1 bg-primary text-white"> M7 </div>
    <div class="field width-1 height-1 bg-primary text-white"> M8 </div>
    <div class="field width-1 height-1 bg-primary text-white"> M9 </div>
    <div class="field width-1 height-1 bg-primary text-white"> M10 </div>
    <div class="field width-1 height-1 bg-primary text-white"> M11 </div>
    <div class="field width-1 height-1 bg-primary text-white"> M12 </div>
    <div class="field width-1 height-1" v-for="item in donator.journal" :key="item"> {{item}} </div>
  </div>
</template>

<script>
export default {
  name: 'DonatorJournal',
  props: {
    donator: {
      type: Object
    }
  },
  data () {
    return {
      list: 34
    }
  }
}
</script>

<style>
  .form {
    min-width: 260px;
    width: 100%;
  }
  .form .field {
    width: 100%;
  }
  .form.form-grid {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-gap: 4px;
  }
  .form.form-grid .field {
    grid-column: auto/span 12;
  }
  .form.form-grid .field.width-1 {
    grid-column: auto/span 1;
  }
  .form.form-grid .field.width-2 {
    grid-column: auto/span 2;
  }
  .form.form-grid .field.width-3 {
    grid-column: auto/span 3;
  }
  .form.form-grid .field.width-4 {
    grid-column: auto/span 4;
  }
  .form.form-grid .field.width-5 {
    grid-column: auto/span 5;
  }
  .form.form-grid .field.width-6 {
    grid-column: auto/span 6;
  }
  .form.form-grid .field.width-7 {
    grid-column: auto/span 7;
  }
  .form.form-grid .field.width-8 {
    grid-column: auto/span 8;
  }
  .form.form-grid .field.width-9 {
    grid-column: auto/span 9;
  }
  .form.form-grid .field.width-10 {
    grid-column: auto/span 10;
  }
  .form.form-grid .field.width-11 {
    grid-column: auto/span 11;
  }
  .form.form-grid .field.width-12 {
    grid-column: auto/span 12;
  }
  .form.form-grid .field.height-1 {
    grid-row: auto/span 1;
  }
  .form.form-grid .field.height-2 {
    grid-row: auto/span 2;
  }
  .form.form-grid .field.height-3 {
    grid-row: auto/span 3;
  }
  .form.form-grid .field.height-4 {
    grid-row: auto/span 4;
  }
  @media (max-width: 700px) {
    .form.form-grid:not(.no-break) .field:not(.no-break) {
      grid-column: auto/span 100 !important;
      grid-row: auto/span 1;
    }
  }
  .field {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #ddd;
    border-radius: 4px;
    min-height: 100px;
  }
  .field:hover {
    border-color: #a0a0a0;
  }

</style>
